import React from "react";
import { FlexContainer } from "@components/ui/flex_container";
import Link from "next/link";
import HorizontalAd from "@components/HorizontalAd/HorizontalAd";
import { SearchBarSlot } from "@components/SharedSearchBar/SharedSearchBar";
import GetTranslatedStrings from "@helpers/GetTranslatedStrings";
import { THEME_COLOR } from "@utils/constants";

export default function FrontPage({ startedSearching }) {
    const t = GetTranslatedStrings();

    // Ræsir sömu leit og þegar notandinn ýtir á Enter í leitarreitnum.
    const triggerSearch = () => {
        if (typeof document === "undefined") {
            return;
        }
        const input = document.querySelector("input.search-bar-input");
        if (input) {
            input.dispatchEvent(
                new KeyboardEvent("keydown", { key: "Enter", code: "Enter", bubbles: true }),
            );
        }
    };

    return (
        <FlexContainer column justifyContent="center" alignItems="center" style={{ flexGrow: 1 }}>
            {!startedSearching && (
                <>
                    <div style={{ paddingTop: "5vh" }}></div>
                    <Link href="/">
                        <a>
                            <img
                                src="/img/1819logo-blue.svg"
                                alt="1819 merki"
                                style={{
                                    height: "15vh",
                                    maxHeight: "160px",
                                    filter: "drop-shadow(0px 2px 2px #00000022)",
                                }}
                            />
                        </a>
                    </Link>
                    <div style={{ paddingTop: "8vh" }}></div>
                    {/* Hólf fyrir sameiginlega leitarreitinn (sjá SharedSearchBar). */}
                    <SearchBarSlot
                        mode="front"
                        style={{ width: "100%", maxWidth: 900, height: 55 }}
                    />
                </>
            )}
            <div style={{ paddingTop: "8vh" }}></div>
            {startedSearching && (
                <>
                    <div
                        style={{
                            color: THEME_COLOR,
                            opacity: 0.5,
                            fontWeight: 600,
                            textAlign: "center",
                            marginBottom: 16,
                            display: "flex",
                            flexWrap: "wrap",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: 6,
                        }}
                    >
                        {t.searchEnterHintBefore}
                        <kbd
                            role="button"
                            tabIndex={0}
                            onClick={triggerSearch}
                            onKeyDown={(e) => {
                                if (e.key === "Enter" || e.key === " ") {
                                    e.preventDefault();
                                    triggerSearch();
                                }
                            }}
                            style={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: 4,
                                fontFamily: "inherit",
                                fontWeight: 700,
                                lineHeight: 1,
                                // Yfirskrifa sjálfgefinn Bootstrap-stíl á <kbd> (dökkgrár bakgrunnur, hvítur texti).
                                color: "inherit",
                                backgroundColor: "transparent",
                                padding: "3px 8px",
                                border: "1px solid currentColor",
                                borderBottomWidth: 3,
                                borderRadius: 6,
                                boxShadow: "0 1px 0 currentColor",
                                cursor: "pointer",
                            }}
                        >
                            <svg
                                width="14"
                                height="14"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2.2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                aria-hidden="true"
                            >
                                <polyline points="9 10 4 15 9 20" />
                                <path d="M20 4v7a4 4 0 0 1-4 4H4" />
                            </svg>
                            Enter
                        </kbd>
                        {t.searchEnterHintAfter}
                    </div>
                    <HorizontalAd adPosition={1} />
                </>
            )}
            <div style={{ paddingTop: "21vh" }}></div>
        </FlexContainer>
    );
}
